import { Component } from "@angular/core";
import { ListPageBase } from "../../../shared/components/list-page-base/list-page-base";
import { AppService } from "../../../app.service";
import { Router } from "@angular/router";
import { StatePersistingService } from "../../../shared/services/state-persisting.service";
import { ExportExcelFromGridService } from "../../../shared/services/export-excel-from-grid.service";
import { LookupService } from "../../../shared/services/lookup.service";
import { ActivityResultSettingListItem } from "../../../shared/models/activity/activity-result-setting-list-item";
import { ActivityResultSettingDto } from "../../../shared/models/activity/activity-result-setting-dto";
import { ActivityResultSettingsService } from "../../../shared/services/activity-result-settings.service";
import { ActivityResultSettingsModal } from "../activity-result-setting-modal/activity-result-setting-modal";
import { DialogService } from "@progress/kendo-angular-dialog";
import { PopupSettings } from "@progress/kendo-angular-dropdowns";
import { KeyValueObject } from "../../../shared/models/core/KeyValueObject";
import { ActivitiesService } from "../../../shared/services/activities.service";
import { ActivityStatusesService } from "../../../shared/services/activity-statuses.service";
import { DataSourceRequestState } from "@progress/kendo-data-query";
import { WorkFlowStepTypeEnum } from "../../../shared/enums/workflow-step-type.enum";
import { ContragentType } from "../../../shared/enums";

@Component({
	selector: 'activity-result-settings-list-page',
	templateUrl: './list.page.html',
	styleUrls: ['./list.page.scss'],
})
export class ActivityResultSettingsListPage extends ListPageBase<ActivityResultSettingListItem> {
    requestTypes: KeyValueObject[] = [];
    clients: KeyValueObject[] = [];
    activityStatuses: KeyValueObject[] = [];
    activityResults: KeyValueObject[] = [];
    filterPopupSettings: PopupSettings = {
        width: 'auto',
        popupClass: 'activity-result-settings-filter-popup'
    };

	constructor(
		appService: AppService,
		router: Router,
        protected dialogService: DialogService,
		protected lookupService: LookupService,
		protected dataService: ActivityResultSettingsService,
        protected activitiesService: ActivitiesService,
        protected activityStatusesService: ActivityStatusesService,
		protected persistingService: StatePersistingService,
		protected exportExcelFromGridService: ExportExcelFromGridService)
	{
		super(router, appService, dataService, persistingService, exportExcelFromGridService);
		appService.pageTitle = 'Настройки результатов активности';
	}

    onListPageInit(): void {
        this.gridSettings.state.sort = [];
        this.gridSettings.state.take = 300;
        this.lookupService.getData('request-types', null).subscribe(data => this.requestTypes = data);
        const clientsState: DataSourceRequestState = {
            filter: {
                logic: "and",
                filters: [{ field: 'contragentTypeId', operator: 'eq', value: <number>ContragentType.bankEquer }]
            }
        };
        this.lookupService.getData('contragents', clientsState).subscribe(data => this.clients = data);
        const activityStatusState: DataSourceRequestState = {
            skip: 0,
            take: null,
            filter: { logic: "and", filters: [{ field: "WorkFlowStepTypeId", operator: "eq", value: WorkFlowStepTypeEnum.final }] }
        };
        this.activityStatusesService.getLookupData(activityStatusState).subscribe(data => this.activityStatuses = data);
        this.activitiesService.getAllActivityResults().subscribe(data => {
            this.activityResults = data.map(x => new KeyValueObject(x.activityResultId, x.activityResult));
        });
		this.setGridSettings(this.gridSettings);
    }

    processListItems(items: ActivityResultSettingListItem[]): void { }

    editSetting(item: ActivityResultSettingListItem) {
        const dialogRef = this.dialogService.open({
            title: `Редактирование настройки №${item.activityResultSettingId}`,
            content: ActivityResultSettingsModal,
            width: '640px'
        });

        let dialog = <ActivityResultSettingsModal>dialogRef.content.instance;
        dialog.setting = { ...item };
    
        dialog.cancelEvent.subscribe(() => {
            dialogRef.close();
        });
        dialog.continueEvent.subscribe(() => {
            dialogRef.close();
            this.loadData();
        });
    }

    createNewSetting() {
        const dialogRef = this.dialogService.open({
            title: 'Создание новой настройки',
            content: ActivityResultSettingsModal,
            width: '640px'
        });

        let dialog = <ActivityResultSettingsModal>dialogRef.content.instance;
    
        dialog.cancelEvent.subscribe(() => {
            dialogRef.close();
        });
        dialog.continueEvent.subscribe(() => {
            dialogRef.close();
            this.loadData();
        });
    }

    copySetting(item: ActivityResultSettingListItem) {
        const dialogRef = this.dialogService.open({
            title: `Копия настройки №${item.activityResultSettingId}`,
            content: ActivityResultSettingsModal,
            width: '640px'
        });

        const dialog = <ActivityResultSettingsModal>dialogRef.content.instance;
        dialog.setting = {
            clientId: item.clientId,
            requestTypeId: item.requestTypeId,
            isArrivedToTSC: item.isArrivedToTSC,
            nextActivityStatusId: item.nextActivityStatusId,
            externalStatus: item.externalStatus,
            externalStatusPriority: item.externalStatusPriority
        } as ActivityResultSettingDto;

        dialog.cancelEvent.subscribe(() => {
            dialogRef.close();
        });
        dialog.continueEvent.subscribe(() => {
            dialogRef.close();
            this.loadData();
        });
    }

    removeHandler({ dataItem }): void {
        this.dataService.remove(dataItem.activityResultSettingId, null, 'Настройка удалена').subscribe(() => {
            this.loadData();
        });
    }
}